(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('itemsSelector', ["path", "$timeout", "$q", "modals", function (path, $timeout, $q, modals) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('items-selector').template(),
            scope: {
                api: '=itemsSelector',
                getItems: '&',
                showFilter: '@?',
                options: '=?',
                disableOnclick: '=?',
                hideLoader: '@?'
            },
            link: function ($scope, element, attrs) {
                $scope.api = $scope.api || {};
                $scope.internal = {
                    items: [],
                    filter: ''
                };
                $scope.pageSize = 6;
                var listElement = element.find('.items-list');
                var haveMore = true;
                var lastItemTop = false;
                var getItems = $scope.api.getItems || $scope.getItems;
                $scope.api.getSelected = function () {
                    return _($scope.internal.items).chain().filter(function (item) {
                        return item.selected;
                    }).map(function (item) {
                        return _(item).omit('display', 'selected', 'uniqueId');
                    }).value();
                };
                $scope.api.clearSelection = function () {
                    _($scope.internal.items).each(function (item) {
                        item.selected = false;
                    });
                };
                $scope.api.reload = function (force) {
                    haveMore = true;
                    $scope.internal.items = [];
                    lastItemTop = false;
                    loadMore(true, force);
                };
                var loadTimeout = $q.defer();
                function loadMore(loadDouble, force) {
                    if (!haveMore) {
                        return;
                    }
                    if ($scope.loading && !force) {
                        return;
                    }
                    loadTimeout.resolve();
                    loadTimeout = $q.defer();
                    $scope.loading = true;
                    var limit = $scope.pageSize * (loadDouble ? 2 : 1);
                    getItems($scope.internal.items.length, limit, $scope.internal.filter, loadTimeout.promise).then(function (response) {
                        if (response.data.rows && response.data.rows.length) {
                            _(response.data.rows).each(function (item, idx) {
                                $.extend(item, {
                                    display: '#' + JSON.stringify({
                                        display: 'linked-text',
                                        text: $scope.api.formatItem(item)
                                    }),
                                    uniqueId: $scope.api.uniqueId(item, idx)
                                });
                                $scope.internal.items.push(item);
                            });
                        }
                        if (response.data.rows.length < limit) {
                            haveMore = false;
                        }
                        $scope.loading = false;
                        lastItemTop = false;
                        $timeout(scrollWatcher);    // to handle cases where pageSize is too small
                    });
                }
                $scope.toggleSelected = function (item) {
                    if ($scope.disableOnclick) {
                        if (_($scope.disableOnclick).find(function (prop) {
                                return prop === 'av_license_enabled' && !item[prop];
                            })) {
                            return modals.confirm({
                                title: 'Warning',
                                message: 'You are about to go to license configuration screen.<br/>' + 'This screen will allow you to assign <strong>this</strong> user a license.<br/>' + 'Going to license configuration screen will discard any changes you\'ve made in the policy so far.<br/>' + 'Are you sure you want to <strong>continue</strong>?',
                                okText: 'Yes',
                                cancelText: 'No',
                                windowClass: 'inline-user-limit-dialog'
                            }).then(function () {
                                window.location.href = item.redirect;
                            });
                        }
                        if (_($scope.disableOnclick).find(function (prop) {
                                return prop !== 'av_license_enabled' && item[prop];
                            })) {
                            return;
                        }
                    }
                    item.selected = !item.selected;
                };
                $scope.doubleClicked = function (event, item) {
                    event.preventDefault();
                    event.stopPropagation();
                    if ($scope.disableOnclick && _($scope.disableOnclick).find(function (prop) {
                            return prop === 'av_license_enabled' && !item[prop] || prop !== 'av_license_enabled' && item[prop];
                        })) {
                        return;
                    }
                    item.selected = true;
                    if ($scope.api.doubleClicked) {
                        $scope.api.doubleClicked();
                    }
                };
                function scrollWatcher() {
                    if (!haveMore || $scope.loading) {
                        return;
                    }
                    if (lastItemTop === false) {
                        var lastItem = listElement.find('.item').not('.loading').last();
                        if (!lastItem.length) {
                            return;
                        }
                        lastItemTop = lastItem[0].offsetTop;
                    }
                    if (lastItemTop < listElement.scrollTop() + listElement.height()) {
                        loadMore();
                    }
                }
                listElement.on('scroll', scrollWatcher);
                $scope.api.reload();
                var filterWatchTimer;
                function setFilter() {
                    $timeout.cancel(filterWatchTimer);
                    $scope.api.reload(true);
                }
                $scope.$watch('internal.filter', function (newValue, oldValue) {
                    if (newValue == oldValue) {
                        return;
                    }
                    filterWatchTimer = $timeout(setFilter, 300);
                });
                $scope.$on('$destroy', function () {
                    listElement.off('scroll', scrollWatcher);
                });
            }
        };
    }]);
}());